import { useState } from "react";
import { canadaFAQData } from "../../data/canadaTaxData";
import { ChevronDown } from "lucide-react";

const FAQItem = ({ item, index }) => {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className={`border-b border-[#E8ECF0] overflow-hidden transition-all duration-200 ${open ? "bg-[#FAFCFF]" : "bg-white hover:bg-[#FAFCFF]"}`}>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 px-0 py-5 text-left group"
      >
        <div className="flex items-center gap-3">
          <span className="text-[#C8283A] font-black text-base flex-shrink-0 w-5 text-center" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>?</span>
          <span className="text-[#0B1829] font-semibold text-sm leading-snug group-hover:text-[#C8283A] transition-colors duration-200" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            {item.q}
          </span>
        </div>
        <ChevronDown
          size={16}
          className={`text-[#8BA3BE] flex-shrink-0 transition-transform duration-300 ${open ? "rotate-180 text-[#C8283A]" : ""}`}
        />
      </button>
      <div
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: open ? "300px" : "0", opacity: open ? 1 : 0 }}
      >
        <p className="pl-8 pb-5 text-[#5A6A7A] text-sm leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {item.a}
        </p>
      </div>
    </div>
  );
};

export const CanadaFAQSection = () => (
  <section id="faq" className="py-24 px-6 bg-[#F3F5F8]">
    <div className="max-w-[87.5rem] mx-auto">
      <div className="mb-14">
        <span className="text-[#C8283A] text-xs font-black uppercase tracking-[0.2em] mb-3 block" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaFAQData.sectionLabel}
        </span>
        <h2 className="text-[#0B1829] font-black leading-tight" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3rem)", letterSpacing: "-0.03em" }}>
          {canadaFAQData.headline1}{" "}
          <span className="text-[#C8283A] italic">{canadaFAQData.headline2}</span>
        </h2>
      </div>

      <div className="max-w-3xl bg-white rounded-2xl border border-[#E8ECF0] overflow-hidden shadow-sm px-6">
        {canadaFAQData.items.map((item, i) => (
          <FAQItem key={i} item={item} index={i} />
        ))}
      </div>
    </div>
  </section>
);
